export default __webpack_public_path__ + "static/balance-guy-1494106138c4134483a37f5e0f84ad0d.png";